/**
 * Layout class manages the layout of the application.
 * It initializes the layout, provides methods to get columns, and handles other layout-related functionalities.
 */
import RepositoryEntry from './RepositoryEntry';
export class Layout extends RepositoryEntry {
    /**
     * Constructor for Layout.
     * @param {Object} entry - The initial data for the task.
     * @param {Object} $injector - AngularJS injector service.
     */
    constructor(entry, $injector) {
        super(entry, $injector);
        this.$injector = $injector;
        this.init();
    }

    /**
     * Initializes the layout.
     * Sets up the layout object in the scope and initializes other necessary components.
     */
    init() {
        /*this.$scope.layout = this;
        this.$scope.layout.context = {};
        this.$scope.layout.data = this.$scope.entry;
        this.$scope.layout.GridCol = this.services.GridCol;
        this.initLayout();*/

        this.readables({
            'type': String,
            'rows': '*'
        });

        this.validators({
            'QPResponsePDFValidator': 'QPResponsePDFValidator'
        });

    }

    /**
     * Retrieves the columns for the layout.
     * @returns {Array} An array of GridCol objects.
     */
    getCols() {
        let result = [],
            rawCols = this.data?.rows?.[0]?.cols,
            idx;

        if (!rawCols) return result;

        for (idx = 0; idx < rawCols.length; idx++) {
            result.push(new GridCol(rawCols[idx], this.context));
        }

        return result;
    }

}

/**
 * Represents a grid column.
 * @class
 */
export class GridCol {
    /**
     * Creates an instance of GridCol.
     * @param {Object} entry - The data entry for the grid column.
     * @param {Object} context - The context object.
     */
    constructor(entry, context) {
        this.data = entry;
        this.context = context;
    }


    /**
     * Retrieves the size of the grid column.
     * @returns {String} The size of the grid column.
     */
    getSize() {
        return this.data['size'];
    }

    /**
     * Retrieves the block of the grid column.
     * @returns {String} The block of the grid column.
     */
    getBlock() {
        return this.data['block'];
    }

    /**
     * Retrieves the content of the grid column.
     * @returns {Object} The content instance.
     */
    getContent() {
        let uuid = this.data['content'],
            result = this.context.readEntryByUUID(uuid),
            type, clazz, instance;

        if (result) {
            type = result.data.type;
            clazz = angular.injector(['assessmentFrontendFactories']).get(type);
            instance = new clazz(result);
        }

        return instance;
    }
}